module.exports = __webpack_public_path__ + "static/media/acc.ea739a5c.svg";